// data-sharing.service.ts
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class DataSharingService {
  private userType: any;
  private id: any;

  setUserType(userType: string) {
    this.userType = userType;
  }

  getUserType(): string {
    return this.userType;
  }

  setId(id: number) {
    this.id = id;
  }

  getId(): number {
    return this.id;
  }
}
